module.exports = __webpack_public_path__ + "img/yunnan02.ae9cc606.png";